const RightSidebar = ({ setUserCity }: { setUserCity: any }) => {
  const cities = [
    "Delhi",
    "Mumbai",
    "Hyderabad",
    "Pune",
    "Chennai",
    "Bangalore",
  ];

  return (
    <div className="lg:col-span-3 bg-white w-full border border-solid border-primary-600 p-4 rounded-[10px] h-[340px]">
      {/* Filter Heading */}
      <span className="font-bold text-[20px] mb-4 block">Filter</span>

      {/* City Checkboxes */}
      <div className="flex flex-col space-y-4">
        {cities.map((city) => (
          <label
            key={city}
            className="flex items-center text-[15px] space-x-4 cursor-pointer flow-root"
          >
            <span className="float-left">{city}</span>

            <div className="float-right">
              <input
                onChange={(e) => {
                  if (e.target.checked) {
                    setUserCity((prev: string[]) => {
                      return [...prev, city];
                    });
                  } else {
                    setUserCity((prev: string[]) => {
                      return prev.filter((item) => item !== city);
                    });
                  }
                }}
                type="checkbox"
                name="city"
                className="w-6 h-6 border-2 border-gray-300 rounded-md"
              />
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RightSidebar;
